import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './menu.module.styl';

import type {ReactNode} from 'react';


const classNames = withCssModule(styles);

export type MenuItemMetaProps = {
    children: ReactNode,
};

/**
 * MenuItemMeta component for MenuItem.
 * It has a special styling for meta information.
 * It has a special text color for ordinary state, and it resets the color for highlighted, disabled, and selected states.
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/utils-listbox--documentation}
 * */
export const MenuItemMeta = ({
    children,
}: MenuItemMetaProps) => {
    return (
        <span className={classNames('menu-item-meta')}>
            {children}
        </span>
    );
};
